<template>
  <form class="ApplicationSection" @submit.prevent @reset.prevent>
    <section
      v-for="section in sections.filter(item => item.id === sectionExpandedId)"
      :key="section.id"
      class="section"
    >
      <div
        v-if="isSectionExpanded(section) && !isSectionDisabled(section)"
        class="sectionFields"
        :id="section.id + '-fields'"
      >
        <ApplicationFieldRow
          v-for="field in section.fields"
          :key="field.apiKey"
          :section="section"
          :field="field"
        />
        <div>
        
        <center>
                <p class="arabicText"><center>بِسْمِ اللهِ الرَّحْمٰنِ الرَّحِيْمِ     فَإِنَّ مَعَ الْعُسْرِ يُسْرًا</center></p>
                <p class="englishText">“In the name of God, the Most Gracious, the Most Merciful”</p>
                <p class="englishText">“verily, with hardship comes ease” [Quran 94:5]</p>
        </center>
        
        </div>
        
        <ApplicationSaveCancel v-if="isApplication" />
      </div>      
    </section>

    
  </form>
</template>

<script>
import { getFirstName, getLabelName } from '@/applicationDefinition/helper'

import ApplicationFieldRow from '@/components/application/ApplicationFieldRow.vue'
import ApplicationSaveCancel from '@/components/application/ApplicationSaveCancel.vue'

const getSectionExpandedId = data => {
  // Prevents null of undefined
  if (data && data.meta) {
    return data.meta.sectionExpandedId
  }
  return ''
}

export default {
  name: 'ApplicationSection',
  components: {
    ApplicationFieldRow,
    ApplicationSaveCancel
  },
  computed: {
    sectionExpandedId() {
      return getSectionExpandedId(this.$store.state.application)
    },
    sections() {
      return this.$store.state.sections
    },
    fields() {
      return this.$store.state.fields
    },
    isApplication() {
      return this.$store.state.application !== null
    }    
    },  
  methods: {   
    toggleSection(section) {
      this.$store.dispatch('set', [
        'application.meta.sectionExpandedId',
        section.id
      ])
    },
    isSectionExpanded(section) {
      return getSectionExpandedId(this.$store.state.application) === section.id
    },
    isSectionDisabled(section) {
      return false
    }
  },
  mounted() {
    this.$store.commit('set', ['auth.isUserActive', true])
    this.$store.commit('set', ['auth.isUserActiveTime', new Date().getTime()])
    this.$store.dispatch('buildAlerts')

  }
}
</script>

<style scoped lang="scss">
.ApplicationSection {
  padding: $content-padding;

  word-wrap: break-word;
  overflow-wrap: break-word;

  .arabicText {
    font-size: 2.8em;
  }

  .englishText {
    font-size: 1.8em;
  }

  .sectionFields {
    padding: 0 0 $content-padding;
  }

  .message {
    display: flex;
    align-items: top;
    margin: $content-padding;
    padding: $content-padding;
    border: 1px solid $color-warning-border;
    border-radius: $field-border-radius;
    background-color: $color-warning;
    font-size: 1.6em;

    .icon {
      margin: 1.8rem 0.4em 0 0.6rem;
      padding: 0;
      width: 100%;
      max-width: 46px;
      font-size: 28px;
      color: $color-red;
    }

    span {
      display: block;
      padding: 1.4rem 0 0;

      button {
        margin: 0;
        padding: 0;
        border: none;
        background: transparent;
        color: $color-secondary;
        font-weight: normal;
        outline: none;

        &.additionalButton {
          font-weight: $text-medium;
        }
      }
    }
  }
}
</style>
